import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from '@sooro-io/react-gtm-module'
import { HelmetProvider } from "react-helmet-async";
import { fetchNonce } from "./products-api";

fetchNonce().then(
    (nonce) => {
        const tagManagerArgs = {
            gtmId: 'GTM-5L2P7HXM',
            nonce: `${nonce}`
        }
        TagManager.initialize(tagManagerArgs);

        const root = ReactDOM.createRoot(
            document.getElementById('root') as HTMLElement
        );
        root.render(
            <React.StrictMode>
                <HelmetProvider>
                    <App nonce={nonce}/>
                </HelmetProvider>
            </React.StrictMode>
        );
    });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
